import { useMemo, useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { StrikerBrand } from '@striker/ui-shell';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => String(searchParams.get('token') || '').trim(), [searchParams]);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    if (password.length < 8) {
      setError('La password deve avere almeno 8 caratteri.');
      return;
    }
    if (password !== confirm) {
      setError('Le password non coincidono.');
      return;
    }
    if (!token) {
      setError('Token mancante. Usa il link ricevuto via email.');
      return;
    }
    setBusy(true);
    try {
      const res = await fetch('/api/v1/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      const body = (await res.json().catch(() => ({}))) as { message?: string; error?: string };
      if (!res.ok) {
        throw new Error(body.error || body.message || `Reset fallito (${res.status})`);
      }
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="sk-login">
      <form className="sk-login__card" onSubmit={onSubmit}>
        <div className="sk-login__brand">
          <StrikerBrand surface="dark" title="StrikerPos" />
        </div>
        <h1 className="sk-page__title">Nuova password</h1>
        <p className="sk-page__lead">
          <Link to="/login">← Torna al login</Link>
        </p>

        {!token ? (
          <p className="sk-error">Link non valido: manca il token.</p>
        ) : (
          <>
            <label className="sk-field">
              <span>Nuova password</span>
              <input
                className="sk-input"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={8}
                required
              />
            </label>
            <label className="sk-field">
              <span>Conferma password</span>
              <input
                className="sk-input"
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                minLength={8}
                required
              />
            </label>
            {error ? <p className="sk-error">{error}</p> : null}
            <button type="submit" className="sk-btn sk-btn--block" disabled={busy}>
              {busy ? 'Salvataggio…' : 'Aggiorna password'}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
